import {
  bestOrderView,
  BestQuoteView,
} from '#/unified-rfqs/ui/rfqs/quotes-functions';
import { Bbo } from '#/unified-rfqs/entities/drfq/bbo';
import { DrfqLeg } from '#/unified-rfqs/entities/drfq/domain';

export interface BestAskBidQuoteView {
  readonly ask: BestQuoteView;
  readonly bid: BestQuoteView;
}

export default function bestAskBidQuoteView(
  bbo: Bbo | null,
  legs: readonly DrfqLeg[] | undefined,
): BestAskBidQuoteView {
  return {
    ask: bestOrderView('SELL', bbo, legs),
    bid: bestOrderView('BUY', bbo, legs),
  };
}
